import React from 'react';
import AdminLayout from './layouts/AdminLayout';
import Dashboard from './pages/Dashboard';
import Administrators from './pages/Administrators';
import Settings from './pages/Settings';
import AdminLogin from './components/AdminLogin';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import TestAdminStore from './components/TestStore';

export const adminRoutes = [
  {
    path: '/admin/login',
    element: <AdminLogin />
  },
  {
    path: '/admin',
    element: (
      <ProtectedAdminRoute>
        <AdminLayout />
      </ProtectedAdminRoute>
    ),
    children: [
      {
        path: 'dashboard',
        element: <Dashboard />
      },
      {
        path: 'administrators',
        element: <Administrators />
      },
      {
        path: 'settings',
        element: <Settings />
      },
      {
        path: 'test-store',
        element: <TestAdminStore />
      }
    ]
  }
]; 